import React, { useEffect } from "react";
import {
  Form,
  Input,
  DatePicker,
  Select,
  Button,
  message,
  Checkbox
 } from 'antd';
 import moment from 'moment';

const { TextArea } = Input;
const { Option } = Select;


const datePickerFormat = 'MMM Do';

const FormItem = Form.Item;

const DayTypeForm = ({ loading, resource, itemDetails, user, confirmDialogue, dayTypesAll, allowTourDayTypes, ...props }) => {
  const { itemType } = itemDetails;
  const { getFieldDecorator, getFieldsError, getFieldsValue, validateFieldsAndScroll } = props.form;

  const invalidForm = () => {
    message.config({
      top: 150,
      duration: 5,
      maxCount: 5,
    });
    message.error('You have one or more invalid form inputs!');
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    validateFieldsAndScroll((err, values) => {
      if (!err) {
        console.log('Success! Received values of form: ', values);
          // check if a dayType already exists on relevent date
          if (itemDetails.resourceDayType.resourceDayTypeId) {
            // dayType exists
            props.updateDayType();
          } else if (!itemDetails.resourceDayType.resourceDayTypeId) {
            // no dayType exists
            props.createDayType();
          }
      } else {
        invalidForm();
        console.log('Invalid Form! ', err);
      }
    });
  };

  const validateCommentField = (rule, value, callback) => {
    const form = props.form;
    if (value.length > 30) {
      callback('Maximum length is 30 characters!')
    } else {
      callback();
    }
  }

    /**
     * populate fields on initial component mount
     * (getFieldDecorator overrides `value` on forms)
     */
    useEffect(() => {
      const form = props.form;
      if (dayTypesAll && itemDetails.resourceDayType) {
         form.setFieldsValue({
          date: moment(itemDetails.date),
          dayType: itemType === 'tour' || itemType === 'off-time' || allowTourDayTypes.find((elem) => elem.id === itemDetails.resourceDayType.dayTypeId) ? `dayTypeId-${itemDetails.resourceDayType.dayTypeId}` : null,
          dayTypeComment: itemDetails.dayTypeComment,
          myDayTypeComment: itemDetails.myDayTypeComment
        });
      }

    }, [dayTypesAll, itemDetails.resourceDayType]);

    if ((dayTypesAll && itemDetails.resourceDayType) || (itemDetails.id && itemDetails.id.split('-')[1] === 'optimistic') ) {
      return (
          <Form onSubmit={handleSubmit}>

          <FormItem
                label="Resource Name"
                style={{ display: "flex", marginBottom: 5 }}
          >
                <Input
                  name="resourceName"
                  value={!itemDetails.id ? resource.name : itemDetails.resourceName}
                  disabled
                  size={'large'}
                  placeholder={''}/>
          </FormItem>

          <FormItem
                label="Date"
                style={{ display: "flex", marginBottom: 5 }}
              >
                {getFieldDecorator('date', {
                      rules: [{
                          required: true, message: 'Please input date!',
                      }]
                  })(
                      <DatePicker
                        name="date"
                        disabled={itemDetails.id ? true : false}
                        onChange={props.handleDayTypeDateChange}
                        format={datePickerFormat}
                        allowClear={false}
                        size={'large'}
                        style={{ width: 120 }}
                        popupStyle={{ zIndex: 2000 }}
                      />
                  )}
              </FormItem>
            <FormItem
                label="Day Type"
                style={{ display: "flex", marginBottom: 5 }}
            >
                {getFieldDecorator('dayType', {
                      rules: [{
                          required: true, message: 'Please input day type!',
                      }]
                  })(
                      <Select
                        name="dayType"
                        onChange={props.handleOmnibusFieldChange}
                        required={true}
                        style={{ width: 250 }}
                      >
                          {/* days with off-time dayTypes or no dayType at all */}
                          { (
                              (
                                itemDetails.itemType === 'off-time'
                              )
                            ||
                               (
                                 itemDetails.itemType === 'dayType'
                                 && !allowTourDayTypes.find((elem) => elem.id == itemDetails.resourceDayType.dayTypeId)
                               )
                            )
                            && dayTypesAll.map((elem) => {
                            return <Option key={elem.dayTypeId} value={`dayTypeId-${elem.dayTypeId}`}>{elem.dayTypeName}</Option>
                          })}
                          {/* days that have a tour on them  or dayTypes that allow tours */}
                          { (
                              itemDetails.itemType === 'tour'
                              || allowTourDayTypes.find((elem) => elem.id == itemDetails.resourceDayType.dayTypeId)
                            )
                            && allowTourDayTypes.map((dayType) => {
                            return <Option key={dayType.id} value={`dayTypeId-${dayType.id}`}>{dayType.name}</Option>
                          })}
                      </Select>
                 )}
            </FormItem>

              <FormItem
                    label="Day Type Comment"
                    style={{ display: "flex", marginBottom: 5 }}
              >
                {getFieldDecorator('dayTypeComment', {
                    rules: [{
                        validator: validateCommentField,
                    }],
                })(
                  <TextArea
                    name="dayTypeComment"
                    onChange={props.handleOmnibusFieldChange}
                    size={'large'}
                    placeholder={'Enter text here.'}/>
                )}
              </FormItem>

              <FormItem
                label="My Day Comment"
                style={{ display: "flex", marginBottom: 5 }}
              >
                {getFieldDecorator('myDayTypeComment', {
                    rules: [{
                        validator: validateCommentField,
                    }],
                })(
                  <TextArea
                    name="myDayTypeComment"
                    onChange={props.handleOmnibusFieldChange}
                    size={'large'}
                    placeholder={'Enter text here.'}/>
                )}
              </FormItem>

              <FormItem
                style={{ marginTop: 20 }}
              >
                <Button disabled={loading} type="primary" ghost size={'large'} htmlType="submit">
                  {loading ? 'loading...' : 'Update'}
                </Button>
                {/* DELETE button should only appear when dayType currently exists */}
                { (itemDetails.id || itemDetails.resourceDayType.resourceDayTypeId)
                  &&
                  <Button disabled={loading} type="danger" ghost size={'large'} onClick={() => props.handleItemDelete('dayType')} >
                  {loading ? 'loading...' : 'Delete'}
                  </Button>
                }
              </FormItem>
          </Form>
      );
    } else return 'loading...';
}

const WrappedDayTypeForm = Form.create()(DayTypeForm);

export default WrappedDayTypeForm;




// WEBPACK FOOTER //
// ./src/Components/Schedule/LiveScheduleUpdate/Forms/DayTypeForm.js